import { VirtualBackground } from './virtualBackground';

import type { JSX } from 'react';

export const VirtualBackgroundMount = (): JSX.Element | null => {
  return <VirtualBackground />;
};
